<template>
<div class="map">
    <l-map
      ref="map"
      :maxZoom="maxZoom"
      :zoom="zoom"
      :minZoom="minZoom"
      :key="mapKey"
      :center="center"
      @click="onMapClick"
      @ready="onMapReady">
        <l-tile-layer :options="{ maxZoom: maxZoom }" :url="tileLayerUrl" :attribution="currentLayer.attribution"></l-tile-layer>
        <!-- <l-wms-tile-layer
        v-for="layer in layers"
        :key="layer.name"
        :base-url="baseUrl"
        :layers="layer.layers"
        :visible="layer.visible"
        :name="layer.name"
        layer-type="base"
      /> -->
        <!-- <l-tile-layer :url="currentLayer.url" :options="{ layers: currentLayer.layers, format: currentLayer.format, transparent: currentLayer.transparent }"></l-tile-layer> -->
        <l-control class="layer-control-create-inventar-map">
            <div class="change-layer">
                <select class="layer-select" v-model="selectedOption" @change="updateTileLayerUrl">
                    <option class="item-select" v-for="(option, index) in options" :key="index" :value="option">
                        {{ option }}
                    </option>
                </select>
            </div>
          </l-control>
        <l-control v-if="notHaveCoordinate" class="without-coordinate">
            <div>
                Dieses Inventar hat keine Koordinaten und kann nicht auf der Karte eingezeichnet werden!
            </div>
        </l-control>
        <l-control class="topright" v-if="isCreatingPolygon">
            <div class="undo-redo-clean">
                <button class="btn" @click="resetMap">
                    <img width="20" height="18" src="../../../../assets/images/clear-points.png" alt="location" />
                    <span>reset</span>
                </button>
                <button class="btn" @click="undoPolygon">
                    <img src="../../../../assets/images/undo.png" alt="add-zones" />
                    <span>undo</span>
                </button>

                <button class="btn" @click="redoPolygon">
                    <img src="../../../../assets/images/redo.png" alt="location" />
                    <span>redo</span>
                </button>
                <button class="btn" @click="closeIsCreatingPolygonMode" style="width:44px;height:44px">
                    <img src="../../../../assets/images/close_white_border.png" alt="location" />
                    <span></span>
                </button>
            </div>
        </l-control>
        <l-control-zoom />
        <l-control class="my-controls">
            <button class="location" @click.prevent="goToMyLocation">
                <img src="../../../../assets/images/my-location.png" alt="location" />
            </button>
            <button class="add-points" @click="togglePolygonCreationMode">
                <img src="../../../../assets/images/add-zones.png" alt="add-zones" />
            </button>
        </l-control>
        <l-layer-group>
            <l-polygon v-for="(swiss,index) in switzerlandCities" :key="`city-${index}`" :lat-lngs="[swiss.coordinates]" :color="cityColor" :options="cityieOptions">
                <l-tooltip class="citites-tooltip" :options="{permanent: true, direction: 'center'}">{{ swiss.city }}</l-tooltip>
            </l-polygon>
            <l-polygon v-for="(zone, index) in mapRegions" :key="`inventar${index}`" :lat-lngs="zone.coordinates" :options="polygonOptions" @click="onZone(zone,zone.id,index)">
                <!-- <l-tooltip ref="tooltip">{{ zone.inventoryId }}</l-tooltip> -->
                <!-- <l-popup ref="popup" :content="JSON.stringify(zone.name)" :options="popupOptions"></l-popup> -->
                <l-tooltip
                    :options="{ permanent: true, direction: 'center' }"
                    :class="selectedOption === 'Cadastral' ? 'custom-polygon-cadastral' : 'custom-polygon'">
                    {{ zone.name }}
                </l-tooltip>
            </l-polygon>
            <template v-for="(point, index) in markers" >

              <l-marker :lat-lng="point" :draggable="false" class="markerTree">
                <l-icon
                :icon-size="[25, 41]"
                :icon-anchor="[13, 41]"
                :icon-url="selectedOption === 'Cadastral'
                    ? require('@/assets/images/cadastral-pin.svg')
                    : require('@/assets/images/pin-map.svg')">
                </l-icon>
              </l-marker>
              </template>
        </l-layer-group>
    </l-map>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import {
    LMap,
    LTileLayer,
    LImageOverlay,
    LPolygon,
    LPolyline,
    LTooltip,
    LLayerGroup,
    LIcon,
    LPopup,
    LControlZoom,
    LControl,
    LGeoJson,
    LMarker,
    LWMSTileLayer
} from "vue2-leaflet";
import axios from "axios";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw";
import L from "leaflet";
export default {
    components: {
        LMap,
        LGeoJson,
        LImageOverlay,
        LTileLayer,
        LPolygon,
        LTooltip,
        LPolyline,
        LLayerGroup,
        LIcon,
        LPopup,
        LControlZoom,
        LControl,
        LMarker,
        "l-wms-tile-layer": LWMSTileLayer,
    },
    props: ['centerr'],
    data() {
        return {
            baseUrl: 'https://s.geo.admin.ch/kye1lki5ob0z',
            centerMapDynamically: null,
            pointMarkers: [],
            minZoom:9,
            maxZoom: 20,
            mapKey: 0,
            center: [46.8182, 8.2275],  // set your initial center
            bounds: [[-26.5, -25]],
            url: `https://tile.openstreetmap.org/{z}/{x}/{y}.png`, // set your tile layer URL
            // url: "http://leafletjs.com/examples/crs-simple/uqm_map_full.png",
            apikey: "AIzaSyC27AbpxpWs0UKZEzUcq-qQ4zDcI_D4jKo",
            // currentLayer: {
            //     name: "",
            // url: `https://map.geo.admin.ch/embed.html?topic=swisstopo&zoom=13&bgLayer=ch.swisstopo.pixelkarte-farbe&lang=en&layers=ch.bav.haltestellen-oev,ch.swisstopo.swissimage-product,ch.swisstopo.geologie-geologischer_atlas.metadata,ch.swisstopo-vd.geometa-nfgeom,ch.swisstopo-vd.geometa-grundbuch,ch.swisstopo-vd.geometa-gemeinde,ch.swisstopo-vd.stand-oerebkataster&layers_timestamp=,current,,,,,&layers_visibility=true,true,false,false,false,false,false&E=2600348.44&N=1197942.32&catalogNodes=1482&layers_opacity=1,1,1,0.75,0.75,0.75,0.75`, // set your tile layer URL
            // apikey: "kOlaYPuPlEZLGataPQ1r",
            // },
            tileLayerUrl:'https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg',
            currentLayer: {
                name: "",
                baseUrl: 'https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg', // Replace with your WMS service URL
                cadastarUrl: 'https://wmts.geo.admin.ch/1.0.0/ch.kantone.cadastralwebmap-farbe/default/current/3857/{z}/{x}/{y}.png', // Replace with your WMS service URL
            },
            selectedOption: 'Standard',
            options: [
                'Standard',
                'Cadastral'
            ],
            clickLatLngs: [],
            isCreatingPolygon: false,
            polygonPoints: [],
            redoPolygonPoints: [],
          polylineArray:null,
          polyline: null,
            mapRegions: [],
          mapRegionsLength: 0,
          lastPolygon: null,
            polygonOptions: {
                fillColor: "#A4A4A4",
                color: "#A4A4A4",
                weight: 1,
                border: " 3px solid #A4A4A4",
                opacity: 1,
                fillOpacity: 0.3,
            },
            cityieOptions: {
                fillColor: "#0e4ab3",
                color: "#0e4ab3",
                weight: 1,
                border: " 3px solid #0e4ab3",
                opacity: 0.6,
                fillOpacity: 0.6,
            },
            polylineOptions: {
              fillColor: "#A4A4A4",
              color: "#A4A4A4",
              weight: 2,
              opacity: 1,
              fillOpacity: 0.5,
            },
            popupOptions: {
                closeButton: false,
                autoClose: false,
                autoOpenPopup: true,
            },
            color: "#A4A4A4",
            cityColor: "#0e4ab3",
            layers: [{
                name: "Regions",
                active: true,
                leafletLayer: null,
                layer: L.layerGroup(),
            }, ],
            notHaveCoordinate:false,
            zoom: 0, // Initial zoom,
            locationCoord:[],
            markers:[],
            coordinates:null
        };
    },
    computed: {
        ...mapGetters(["mapRegionData", "error", "loggedInUser", "switzerlandCities"]),
    },
    watch: {
      isCreatingPolygon: function (newVal) {
        // disable map dragging on creating polygon
        if (newVal && L.Browser.mobile)
          this.$refs.map.mapObject.dragging.disable()
        else
          this.$refs.map.mapObject.dragging.enable()
      }
    },
    methods: {
        updateTileLayerUrl() {
            if (this.selectedOption === 'Cadastral') {
                this.tileLayerUrl = this.currentLayer.cadastarUrl;
                this.centerMapOnZoneFromIn()
            } else {
                this.tileLayerUrl = this.currentLayer.baseUrl;
                this.centerMapOnZoneFromIn()
            }
            this.mapKey++;
        },

        onZone(zone, id, index) {
        },
        onMarkerDragEnd(event, index) {
            // this.$set(this.polygonPoints, index, latlng);
            const latlng = event.target.getLatLng();
            const newLat = latlng.lat;
            const newLng = latlng.lng;
            this.$set(this.polygonPoints, index, [newLat, newLng]);
            this.savePolygon();
        },
        goToMyLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const latlng = [position.coords.latitude, position.coords.longitude];
                    this.markers.push([latlng[0], latlng[1]]);
                    // this.locationCoord = [latlng]
                    this.$refs.map.mapObject.setView(latlng, 18); // Set the map view to your location with zoom level 15
                });
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        },
        onPointDragged(event, index) {
            const latlng = event.target.getLatLng();
            this.$set(this.polygonPoints, index, [latlng.lat, latlng.lng]);
            this.createPointMarkers();
            this.drawPolyline();
            this.savePolygon();
        },

        // changeTileLayer(layer) {
        //   this.selectedLayer = layer;
        //   this.currentLayer = layer;
        // },
        //    onMapClick(e) {
        //     const latlng = e.latlng;
        //     this.clickLatLngs.push([latlng.lat, latlng.lng]);
        //      if (this.clickLatLngs.length >= 3) {
        //       const lastIndex = this.mapRegions.length - 1;
        //       const lastRegion = this.mapRegions[lastIndex].region;
        //       lastRegion.push(this.clickLatLngs);
        //       this.clickLatLngs = [];
        //       const obj = {
        //         inventoryId: 152,
        //         name: "inventory i ri",
        //         lastRegion
        //       }
        //       this.mapRegions.push(obj)
        //       this.$emit('items-updated', this.clickLatLngs);
        //     }

        // },
        onMapReady() {
            this.mapReady = true;
        },
        onMapClick(event) {
            if (this.isCreatingPolygon) {
                this.polygonPoints.push([event.latlng.lat, event.latlng.lng]);
                this.createPointMarkers(); // re-create all
                this.drawPolyline();
                this.savePolygon();
            }
        },

        clearPointMarkers() {
            this.pointMarkers.forEach(marker => {
                this.$refs.map.mapObject.removeLayer(marker);
            });
            this.pointMarkers = [];
        },

        createPointMarkers() {
            this.clearPointMarkers();
            // add for each polygon point
            this.polygonPoints.forEach((latlng, index) => {
                const marker = L.marker(latlng, {
                    draggable: true,
                    icon: L.divIcon({
                        className: 'custom-point-icon',
                        html: `<svg width="14" height="14"><circle cx="7" cy="7" r="5" fill="#2E6B45" stroke="#fff" stroke-width="2"/></svg>`
                    })
                })
                .addTo(this.$refs.map.mapObject)
                .on('dragend', (e) => this.onPointDragged(e, index));
                this.pointMarkers.push(marker);
            });
        },

        drawPolyline(){
            if (this.polyline) {
            // clear polyline on map
            this.$refs.map.mapObject.removeLayer(this.polyline);
            }

            // add polyline to map
            this.polyline = L.polyline(this.polygonPoints, this.polylineOptions);
            this.polyline.addTo(this.$refs.map.mapObject);
        },

        drawPolygon() {
            // Always remove the old polygon if it exists
            if (this.lastPolygon) {
                this.$refs.map.mapObject.removeLayer(this.lastPolygon);
                this.lastPolygon = null;
            }

            // Only draw if there are enough points
            if (this.polygonPoints.length > 2) {
                this.lastPolygon = L.polygon(this.polygonPoints, this.polygonOptions);
                this.lastPolygon.addTo(this.$refs.map.mapObject);
            }
        },

        resetMap() {
            const map = this.$refs.map.mapObject;

            // Remove existing polyline if present
            if (this.polyline) {
                map.removeLayer(this.polyline);
                this.polyline = null;
            }

            // Remove draggable point markers
            this.clearPointMarkers();

            // Remove polygon if it exists
            if (this.lastPolygon) {
                map.removeLayer(this.lastPolygon);
                this.lastPolygon = null;
            }

            // Reset the polygon points array
            this.polygonPoints = [];
            this.redoPolygonPoints = [];

            // Inform parent and persist empty state
            this.$emit("latlngs-updated", this.polygonPoints);
            this.savePolygon();
        },
        undoPolygon() {
            if (this.polygonPoints.length === 0) return;
            const last = this.polygonPoints.pop();
            this.redoPolygonPoints.push(last);
            this.createPointMarkers();
            this.drawPolyline();
            this.drawPolygon();
            this.$emit("latlngs-updated", this.polygonPoints);
        },

        redoPolygon() {
            if (this.redoPolygonPoints.length === 0) return;
            const last = this.redoPolygonPoints.pop();
            this.polygonPoints.push(last);
            this.createPointMarkers();
            this.drawPolyline();
            this.drawPolygon();
            this.$emit("latlngs-updated", this.polygonPoints);
        },


        togglePolygonCreationMode() {
            if (this.isCreatingPolygon) {
                // Turning OFF edit mode
                this.clearPointMarkers();   // remove the draggable points
            } else {
                // Turning ON edit mode
                if (this.polygonPoints.length > 0) {
                    this.createPointMarkers(); // show draggable points
                }
          }
          this.isCreatingPolygon = !this.isCreatingPolygon;
        },
        closeIsCreatingPolygonMode() {
            this.isCreatingPolygon = false;
        },
        savePolygon() {
            // Send the polygonPoints array to the database
            // and store the new polygon in this.mapRegions
            this.mapRegions[this.mapRegionsLength] = { coordinates: this.polygonPoints, }
            this.$emit("latlngs-updated", this.polygonPoints);
            this.drawPolygon()
        },
        handeldata(data) {
            this.mapKey += 1;
            setTimeout(() => {
                this.center = data;
            }, 100);
        },
        ...mapActions(["mapRegion"]),
        setMapDataRegions() {
            axios
                .get("/api/Inventory/MapRegion")
                .then((response) => {
                    this.mapRegions = response.data;
                    this.mapRegionsLength = this.mapRegions?.length || 0;
                })
                .catch((error) => {
                    // Handle Errors here.
                    // var errorCode = error.code;
                    // var errorMessage = error.message;
                    console.log(error);

                    // ...
                });
        },
        centerMapOnZoneFromIn() {
            // Find the average latitude and longitude of all points in the zone
            const defaultCoordinates = "[[47.211785,7.541221],[47.211811,7.541753],[47.211541,7.541522]]"
            const latlngs = this.coordinates ? this.coordinates : JSON.parse(defaultCoordinates);
            if(this.$route.params.id){
                if(this.coordinates){
                    this.notHaveCoordinate = false
                } else {
                    this.notHaveCoordinate = true
                }
            }
            const latlngBounds = L.latLngBounds(latlngs);
            const center = latlngBounds.getCenter();

            // Use Leaflet's fitBounds method to set the map view to display the entire zone
            this.$refs.map.mapObject.fitBounds(latlngBounds);

            // Update the component's center and zoom properties to reflect the new map view
            this.center = [center.lat, center.lng];
            this.zoom = this.coordinates ? this.$refs.map.mapObject.getZoom() : 14;
        },
        onZoomEnd() {
            this.zoom = this.$refs.map.mapObject.getZoom(); // Update the zoom property
          console.log('on zoom', this.$refs.map.mapObject.getZoom())
        },
        eventFromParent(){
            const defaultCoordinates = "[[47.211785,7.541221],[47.211811,7.541753],[47.211541,7.541522]]"
            this.$parent.$on('send-cordinates', (dataFromParent) => {
                this.coordinates = dataFromParent && dataFromParent.length > 0 ? dataFromParent : JSON.parse(defaultCoordinates);

                if (dataFromParent.length === 0) {
                    this.notHaveCoordinate = true;
                } else {
                    this.notHaveCoordinate = false;

                    this.polygonPoints = [...this.coordinates];

                    this.clearPointMarkers();
                    if (this.polyline) {
                        this.$refs.map.mapObject.removeLayer(this.polyline);
                        this.polyline = null;
                    }
                    if (this.lastPolygon) {
                        this.$refs.map.mapObject.removeLayer(this.lastPolygon);
                        this.lastPolygon = null;
                    }

                    this.drawPolygon();
                    this.drawPolyline();

                    this.isCreatingPolygon = false;

                    const latlngBounds = L.latLngBounds(dataFromParent);
                    const center = latlngBounds.getCenter();

                    // Use Leaflet's fitBounds method to set the map view to display the entire zone
                    this.$refs.map.mapObject.fitBounds(latlngBounds);

                    // Update the component's center and zoom properties to reflect the new map view
                    this.center = [center.lat, center.lng];
                    this.zoom = this.$refs.map.mapObject.getZoom();
                }

            });
        }

    },
    created() {
        this.setMapDataRegions();
    },
    beforeUnmount() {
        // Remove the zoomend event listener before unmounting the component
        this.$refs.map.mapObject.off("zoomend", this.onZoomEnd);
    },
    mounted() {
        this.$refs.map.mapObject.on("zoomend", this.onZoomEnd);
        this.eventFromParent();

        this.$parent.$on("my-event", this.handeldata);
        this.mapRegions.forEach((el, index) => this.$refs.popup[index].openPopup());
    },
};
</script>

<style lang="scss">
.map {
    width: 100%;
    height: 100%;

    .citites-tooltip{
        color: #7f1111;
    }

    .custom-point-icon {
        background: transparent;
        border: none;
        svg {
            display: block;
        }
    }

    .layer-control-create-inventar-map{
        position: absolute;
        top: 0;
        right: 0;
        .change-layer{
              position: absolute;
              top: -10px;
              right: 43px;
              width: 130px;
              height: 53px;
              background-color: #2a2b2a;
              opacity: 0.8;
              color: #fff;

              .layer-select{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                text-align: center;
                color: #fff;

                .item-select{
                  width: 100%;
                  color: #fff;
                  font-size: 15px;
                  background-color: #2a2b2a;
                }
              }
          }
    }
    .leaflet-control-attribution{
        display: none !important;
    }
    .without-coordinate{
        color: #2A2B2A;
        font-size: 20px;
        position: relative;
        top: 120px;
        text-align: center;
        background: #fff;
    }
    .leaflet-tooltip {
        background-color: transparent;
        border: 0;
        font-size: 22px;
        box-shadow: none;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #2A2B2A;
    }

    .leaflet-control-zoom-in,
    .leaflet-control-zoom-out {
        background-color: #fff;
    }

    .leaflet-left .leaflet-control-zoom {
        display: none;
    }

    .leaflet-right .leaflet-control-zoom {
        position: relative;
        top: 271px;
        right: -10px;
        background: #2a2b2a;
        opacity: 0.8;
    }

    .leaflet-right .leaflet-control-zoom .leaflet-bar {
        border-radius: none;
    }

    .leaflet-touch .leaflet-bar a {
        background: #2a2b2a;
        opacity: 0.8;
        color: white;
    }

    .my-controls {
        position: relative;
        top: 261px;
        right: -10px;
        /* padding: 1.8px; */
        background: #2a2b2a;
        opacity: 0.8;
        /* border-top-left-radius: 2px; */
        /* border-top-right-radius: 2px; */
        background: #2a2b2a;
        opacity: 0.8;
        /* width: 30px; */
        padding-bottom: 5px;
        padding-top: 0px;
        display: flex;
        flex-direction: column;
        align-items: center;

        button.location {
            color: white;
            width: 34px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
            /* text-align: center; */
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 6px;
            border-top: 1px solid #a4a4a4;
            padding-top: 7px;
            cursor: pointer;
        }

        button.add-points {
            border-top: 1px solid #a4a4a4;
            padding-top: 10px;
            cursor: pointer;
        }
    }



        .topright {
         position: absolute;
         top: -10px;
        right: -10px;
        .undo-redo-clean {
            background: #2a2b2a;
            opacity: 0.8;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 10px;
                border-right: 1px solid #a4a4a4;
                padding-right: 10px;
                cursor: pointer;
            }

            .btn:last-child {
                border-right: none;
            }

            span {
                margin-top: 5px;
            }
        }
    }
}
.custom-polygon-cadastral {
        color: #2E6B45 !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        }
</style>
